module.exports = __webpack_public_path__ + "static/media/fa-solid-900.9da86093.woff2";